import { useCallback } from 'react'
import { getSubmit } from 'ui-seeker/utils'
import { useContextSelector } from 'use-context-selector'
import { AppMainHotelsContext } from 'app/providers'
import { FORM_URL } from 'app/@common/constants'

export default function useSetHotel() {
    const updateMainHotels = useContextSelector(AppMainHotelsContext, ({ updateState }) => updateState)

    const setHotel = useCallback((idHotel, { remount = false } = {}) => {
        return getSubmit(FORM_URL.SET_HOTEL, { idHotel })
            .then(({ hotelID = null }) => {
                if (hotelID) localStorage.setItem('selectedMainHotel', hotelID)
                const update = { mainHotels: idHotel }
                if (remount) update.forceRemount = Date.now()
                updateMainHotels(update)
                return hotelID
            })
    }, [updateMainHotels])

    return { setHotel }
}
